module.exports = __webpack_public_path__ + "img/thumb.04cf0cdb.jpeg";